export default class OauthService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
    integrationService
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.integrationService = integrationService;
  }

  getAuthUrl(accountId, provider, callbackUrl) {
    let url = this.#serviceUserBaseUrl(accountId) + '/' + this.integrationService.getProviderUrlMap(provider.toLowerCase()) + '/authurl';

    if (callbackUrl) {
      const parsed = new URL(url);
      parsed.searchParams.set('redirectUrl', callbackUrl);
      url = parsed.toString();
    }

    return this.$http.get(url);
  }

  saveOauthData(accountId, provider, data) {
    return this.$http.post(this.#serviceUserBaseUrl(accountId) + '/' + this.integrationService.getProviderUrlMap(provider) + '/callback', data);
  }

  #serviceUserBaseUrl(accountId) {
    return this.ngAuthSettings.apiServiceBaseUri + accountId + '/oauth';
  }
}
